<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-text-field clearable dense label="优惠券名称" outlined v-model="query.caption">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select v-model="query.status" :items="query.statusItems" item-text="text" item-value="value" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn small @click="showAddDialog" color="info">添加优惠券</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					<!-- <v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip> -->
					<span v-if="item.status=='0'" style="color:red">作废</span>
					<span v-if="item.status=='1'">正常</span>
				</template>
				
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showUpdate(item)" color="info" small>修改</v-btn>
					<v-btn @click.stop="frozenCoupon(item)" :disabled="item.status !== '1'" color="info" class="ml-3" small>作废</v-btn>
					<v-btn @click.stop="freeCoupon(item)" :disabled="item.status === '1'" color="info" class="ml-3" small>启用</v-btn>
					
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="添加优惠券" v-model="add.dialog" max-width="600">
			<v-card>
				<v-card-title>添加优惠券</v-card-title>
				<v-card-text>
					<v-row dense>
						
						<v-col cols="12">
							<v-text-field label="优惠券名称" v-model="add.coupon.caption" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="面值" type="number" v-model="add.coupon.faceValue" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="满多少可以使用" type="number" v-model="add.coupon.limitAmount" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-menu ref="menuExpireDate" v-model="add.menuExpireDate" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.coupon.expireDate" label="过期日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.coupon.expireDate" locale="zh-cn" @input="add.menuExpireDate=false" no-title scrollable>
								</v-date-picker>
							</v-menu>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 修改dialog -->
		<v-dialog title="修改优惠券" v-model="update.dialog" max-width="600">
			<v-card>
				<v-card-title>修改优惠券</v-card-title>
				<v-card-text>
					<v-row dense>
						
						<v-col cols="12">
							<v-text-field label="优惠券名称" v-model="update.coupon.caption" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="面值" type="number" disabled v-model="update.coupon.faceValue" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="满多少可以使用" type="number" v-model="update.coupon.limitAmount" dense outlined></v-text-field>
						</v-col>
						
						<v-col cols="12">
							<v-menu ref="menuExpireDate1" v-model="update.menuExpireDate" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.coupon.expireDate" label="过期日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="update.coupon.expireDate" locale="zh-cn" @input="update.menuExpireDate=false" no-title scrollable>
								</v-date-picker>
							</v-menu>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdate" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	</v-card>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "coupon-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '优惠券管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						
						{
							text: '优惠券名称',
							value: 'caption',
							sortable: false
						},
						{
							text: '面值',
							value: 'faceValue',
							sortable: false
						},
						{
							text: '使用金额限制',
							value: 'limitAmount',
							sortable: false
						},
						{
							text: '过期日期',
							value: 'expireDate',
							sortable: false
						},
						{
							text: '发放数量',
							value: 'giveCount',
							sortable: false
						},
						{
							text: '已用数量',
							value: 'usedCount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					caption: "",
					status:"1",
					statusItems:[
						{value:"",text:"全部"},
						{value:"1",text:"正常"},
						{value:"0",text:"作废"},
					]
				},
				add: {
					dialog: false,
					coupon: {
						caption: "",
						faceValue:"",
						limitAmount:"",
						limitShop:"",
						expireDate:""
					},
					menuExpireDate:false,
				},
				update: {
					dialog: false,
					coupon: {
						id:"",
						caption: "",
						faceValue:"",
						limitAmount:"",
						limitShop:"",
						expireDate:""
					},
					menuExpireDate:false,
				},
			}
		},
		created() {
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog() {
				this.add.dialog = true;
				
				// 清空add历史数据
				this.add.coupon.caption = "";
				this.add.coupon.faceValue = "";
				this.add.coupon.limitAmount = "";
				this.add.coupon.expireDate = "";
				
			},
			showUpdate(item){
				this.update.coupon.id = item.id;
				this.update.coupon.caption = item.caption;
				this.update.coupon.faceValue = item.faceValue;
				this.update.coupon.limitAmount = item.limitAmount;
				this.update.coupon.expireDate = item.expireDate;
				
				this.update.dialog = true;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/financial/coupon/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if(shopId){
					url += "&shopId=" + shopId;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.caption) {
					url += "&caption=" + this.query.caption;
				}
				if(this.query.status){
					url += "&status=" + this.query.status;
				}
				
			
				this.axios.get(url).then(response => {
					
					console.log("coupon list res:",response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAdd() {

				if (!this.add.coupon.caption) {
					this.$noty.error('优惠券名称不能为空');
					return
				}
				
				if (!this.add.coupon.faceValue) {
					this.$noty.error('金额不能为空');
					return
				}
				
				const shopId = utils.getCurrentShopId();
			
				// api
				const that = this;
				let url = `/financial/coupon/create`;
				let postData = {...this.add.coupon};
				postData.limitShop = shopId;
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			submitUpdate() {
			
				if (!this.update.coupon.caption) {
					this.$noty.error('优惠券名称不能为空');
					return
				}
				
				// api
				const that = this;
				let url = `/financial/coupon/update`;
				let postData = {...this.update.coupon};
				
			
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.update.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			},
			
			frozenCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/coupon/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeCoupon(item){
				//解冻
				const that = this;
				let url = `/financial/coupon/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getShopListForSelect(){
				const that = this;
				let url = `/sys/merchant/shop/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>

<style>
</style>
